import React, { useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";
import HttpClientXml from "../../../utils/HttpClientXml";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function AddMenuAccess() {
  const [userId, setUserId] = useState("");
  const [cityIds, setCityIds] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [isDropdownRoleOpen, setIsDropdownRoleOpen] = useState(false);
  const dropdownRolesRef = useRef(null);
  const [roleIds, setRoleIds] = useState([]);
  const navigate = useNavigate();

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [cities, setCities] = useState([]);
  const [staffs, setStaffs] = useState([]);



  const [roles, setRoles] = useState([
    {
      _id: "sales",
      name: "sales"
    },
    {
      _id: "survey",
      name: "survey"
    },
    {
      _id: "telecalling",
      name: "telecalling"
    },
    {
      _id: "data entry",
      name: "data entry"
    },
    {
      _id: "branch manager",
      name: "branch manager"
    },
    {
      _id: "freelancer",
      name: "freelancer"
    },
    {
      _id: "superadmin",
      name: "superadmin"
    }
  ]);

  const initialFormData = {
    menuName: "",
    accessRole: [],
  }
  const [formData, setFormData] = useState(initialFormData)

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find(item => item._id === userCity)])
          // setSelectedCity(userCity)
          setFormData({ ...formData, city: userCity })
          fetchStaffs(userCity)
        } else {
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  }

  // Fetch staffs
  const fetchStaffs = async () => {
    try {
      const res = await HomeService.getStaffs();
      console.log("UYT99", res.data);

      if (res?.data) {
        formData?.city && formData?.role && setStaffs(res.data.filter((item) => item?.city._id === formData?.city && item.role === formData?.role))
        formData?.city && !formData?.role && setStaffs(res.data.filter((item) => item?.city._id === formData?.city));
      }
    } catch (error) {
      console.error("Error fetching staffs:", error);
    }
  }





  useEffect(() => {
    fetchCities();
  }, [])

  useEffect(() => {
    fetchStaffs()
  }, [formData.city, formData.role])



  const [buttonText, setButtonText] = useState("Send email")

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.city) { return toast.error("Select City") }
    if (!formData.role) { return toast.error("Select Role") }
    if (formData.recipients.length === 0) { return toast.error("Choose Staff") }
    console.log("UYT180", formData);
    setButtonText("Sending emails. Please wait...")
    // return
    try {
      const res = await HomeService.sendMailToStaff(formData);
      if (res?.success) {
        toast.success(res?.message);
        setFormData(initialFormData)
        setButtonText("Send another email")
        navigate("/sent-email-to-staff");
      }
    } catch (error) {
      toast.error("Failed to send email.");
      console.error("Error sending email:", error);
    }
  };




  const handleRoleChange = (e) => {
    const value = e.target.value;
    setRoleIds(
      (prev) =>
        prev.includes(value)
          ? prev.filter((_id) => _id !== value) // Remove if already selected
          : [...prev, value] // Add if not selected
    );
    setAllSelected(false)
  };

  useEffect(() => {
    setFormData({ ...formData, recipients: roleIds })
  }, [roleIds])

  const [allSelected, setAllSelected] = useState(false)
  const handleAllRoles = (e) => {
    console.log("JUY164", roles, roleIds, e.target.value);
    let allStaffs = staffs.map(item => item._id);
    if (allSelected) {
      allStaffs = []
    }
    setRoleIds(allStaffs)
    setAllSelected(!allSelected)

  };



  const toggleDropdownRole = () => {
    setIsDropdownRoleOpen(!isDropdownRoleOpen); // Toggle dropdown visibility
  };



  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Menu Access
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">





                <div className="col-md-6 mt-3">
                  <label>
                    Menu Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="menuName"
                    value={formData?.menuName}
                    onChange={(e) => {
                      setFormData({ ...formData, menuName: e.target.value })
                    }}
                    placeholder="Enter menu name"
                  />
                </div>


                <div className="col-md-6 mt-3">
                  <label>
                    Roles<span className="text-danger">*</span>
                  </label>


                  <div className="dropdown" ref={dropdownRolesRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdownRole}
                    >
                      {roleIds.length === 0
                        ? roles.length > 0 ? "Select Role(s)" : "No roles found"
                        : `${roleIds.length} role selected`}
                    </button>
                    {isDropdownRoleOpen && roles.length > 0 && (
                      <div className="dropdown-menu-for-city">
                        {
                          roles.length > 0 &&
                          <div className="form-check"
                            style={{
                              borderBottom: "solid 1px #eee"
                            }}
                          >
                            <input
                              type="checkbox"
                              id="s_all" // Properly linking with label
                              value="all"
                              checked={allSelected}
                              onChange={handleAllRoles}
                              className="form-check-input"
                            />
                            <label
                              className="form-check-label"
                            >
                              Select all
                            </label>
                          </div>
                        }

                        {roles.map((item, index) => (
                          <div key={index} className="form-check">
                            <input
                              type="checkbox"
                              id={`city-${index}`}
                              value={item}
                              checked={roleIds.includes(item)}
                              onChange={handleRoleChange}
                              className="form-check-input"
                            />
                            <label
                              className="form-check-label"
                            >
                              {item.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                {/* </div> */}

              </div>


              <button type="submit" style={{
                background: 'rgb(133, 218, 79)',
                borderRadius: '13px'
              }} className="btn mt-3">
                {buttonText}
              </button>

            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddMenuAccess;
